export default __webpack_public_path__ + "23c9da132805f23932ed4fbb9171aba4.svg";